export const fetchWithTimeout = async (url, options = {}, timeOut = 5000) =>{
    const controller = new AbortController();
    const id = setTimeout(()=>controller.abort(), timeOut);
    try{
        const res = await fetch(url, {
            ...options,
            signal: controller.signal
        });
        clearTimeout(id);
        return res;
    }
    catch (err) {
        clearTimeout(id);
        throw err;
    }
}